const actions = {
    async handleKickFromRoom({dispatch}, data) {
      let res = await dispatch('api/nav/kickFromRoom', data);
      dispatch('analytics/kickGuestFromRoom', data)

      if(res.success) {
        dispatch('popups/show/success/custom', 'Kicked user from the room', {root: true})
      } else {
        dispatch('popups/show/error/custom', 'kicking user from the room. <br><br> If this user is a host, you won\'t be able to kick them out', {root: true})
      }
      return res
    },
    async handleKickedFromRoom({dispatch, rootGetters}, data) {
      let myUserId = rootGetters['current_user/id']
      if (data.userId !== myUserId) return // this dont concern me

      if (rootGetters['current_user/isGuest'] || rootGetters['current_user/isExternalGuest']) {
        await dispatch('guest/room/returnToRoomLobby', [true])
      } else {
        await dispatch('handleLeaveRoom')
        dispatch('popups/show/error', { message: 'You have been removed from the Room.' }, {root: true})
      }
    }
  };

  export default {
    actions
  };
